import INBOX from 'INBOX';

INBOX.namespace('classes.User', function () {
    return function (name, domain) {
        this.name = name;
        this.domain = domain;

        this.getEmail = function () {
            return this.name + '@' + this.domain;
        };
    };
});